const AUTHORIZATION_RESET_SUPPORTED_TICKET_TYPES = new Set(['RTEDR', 'RTE', 'VDO']);
const PAYMENT_SUPPORTED_TICKET_TYPES = new Set(['RTE', 'RTEDR']);
const RETURN_REVIEW_SUPPORTED_TICKET_TYPES = new Set(['RTEDR', 'RTE', 'VDO']);
const BLOCK_PRO_SUPPORTED_TICKET_TYPES = new Set(['RTEDR', 'RTE']);
const DOCUMENT_REVIEW_SUPPORTED_TICKET_TYPES = new Set(['RTEDR']);

export const supportsAuthorizationReset = (ticketType) => { 
    return AUTHORIZATION_RESET_SUPPORTED_TICKET_TYPES.has(ticketType);
}

export const supportsPayment = (ticketType) => {
    return PAYMENT_SUPPORTED_TICKET_TYPES.has(ticketType);
}

export const supportsReturnReview = (ticketType) => {
    return RETURN_REVIEW_SUPPORTED_TICKET_TYPES.has(ticketType);
}

export const supportsBlockPro = (ticketType) => {
    return BLOCK_PRO_SUPPORTED_TICKET_TYPES.has(ticketType);
}

export const supportsDocumentReview = (ticketType) => {
    return DOCUMENT_REVIEW_SUPPORTED_TICKET_TYPES.has(ticketType);
}